import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { IcosTagsModule} from '../tag/module'
import { IcosInputsModule } from '../input/module'
import { IcosSelectDropdown } from './select-dropdown'
import { IcosOption } from './option'
import { IcosSelect } from './select'


@NgModule({
  declarations: [IcosSelectDropdown, IcosOption, IcosSelect],
  exports: [IcosSelectDropdown, IcosOption, IcosSelect],
  imports: [CommonModule, FormsModule, IcosTagsModule, IcosInputsModule],
  entryComponents: [IcosSelectDropdown, IcosOption, IcosSelect],
})
export class IcosSelectModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosSelectModule, providers: [] }
  }
}
